import { inject, Injectable } from '@angular/core';

import { ENVIRONMENT_INJECTION_TOKEN } from '@sbd-doug-frontend/shared/lib/injections/environment-injection-token';

@Injectable({providedIn: 'root'})
export class LoggingService {
  private _environment = inject(ENVIRONMENT_INJECTION_TOKEN);

  log(message: string, ...args: any[]) {
    if(this._environment.production === false) {
      console.log(message, ...args);
    }
  }

  error(message: string, ...args: any[]) {
    if(this._environment.production === false) {
      console.error(message, ...args);
    }
  }

  warn(message: string, ...args: any[]) {
    if(this._environment.production === false) {
      console.warn(message, ...args);
    }
  }

  info(message: string, ...args: any[]) {
    if(this._environment.production === false) {
      console.info(message, ...args);
    }
  }
}
